import { LoadingPanels } from "app/components/analytics/shared/LoadingStates";
import { Build, Job } from "app/components/build/Show/lib/types";
import {
  keyValueToTag,
  RESULT_KEY,
} from "app/components/analytics/shared/tagHelpers";

type Props = {
  build: Build;
  job?: Job;
};

export default function V2TestEngine({ build, job }: Props) {
  const tagParams = keyValueToTag(RESULT_KEY, "failed");
  const params = `build_id=${build.id}${job ? `&job_id=${job?.id}` : ""}&tags=${tagParams}`;
  const id = `build_tests_${build.id}${job ? `_${job.id}` : ""}`;

  return (
    <turbo-frame
      class={`w-full h-full relative overflow-y-auto ${Features.BuildSidebar ? " p-4" : " p-2"}`}
      id={id}
      src={`/organizations/${build.account.slug}/analytics/build_tests?${params}`}
    >
      <LoadingPanels rows={10} columns={1} />
    </turbo-frame>
  );
}
